import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram, Facebook } from "lucide-react";
import Logo from "@/components/Logo";
import { NAV_LINKS } from "@/lib/site";
import { useSettings } from "@/context/SettingsContext";

const LEGAL = [
  { label: "Kiralama Koşulları", to: "/kiralama-kosullari" },
  { label: "Gizlilik Politikası", to: "/gizlilik-politikasi" },
  { label: "KVKK Aydınlatma Metni", to: "/kvkk" },
  { label: "Çerez Politikası", to: "/cerez-politikasi" },
];

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="bg-[#171717] text-neutral-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="space-y-4">
            <Logo className="h-11" />
            <p className="text-sm text-neutral-400 leading-relaxed">
              VoyaCar Rental ile İstanbul'da ekonomik, konforlu ve bakımlı araçları kolayca kiralayın. Güvenilir ve şeffaf araç kiralama deneyimi.
            </p>
            <div className="flex gap-3">
              {settings.instagram && (
                <a href={settings.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="p-2 rounded-full bg-white/10 hover:bg-[#A11016] transition-colors"><Instagram className="h-4 w-4" /></a>
              )}
              {settings.facebook && (
                <a href={settings.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="p-2 rounded-full bg-white/10 hover:bg-[#A11016] transition-colors"><Facebook className="h-4 w-4" /></a>
              )}
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Hızlı Bağlantılar</h4>
            <ul className="space-y-2.5 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.to}><Link to={l.to} className="hover:text-[#A11016] transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Araç Kategorileri</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/araclar?segment=ekonomik" className="hover:text-[#A11016] transition-colors">Ekonomik</Link></li>
              <li><Link to="/araclar?segment=orta" className="hover:text-[#A11016] transition-colors">Orta Segment</Link></li>
              <li><Link to="/araclar?segment=suv" className="hover:text-[#A11016] transition-colors">SUV</Link></li>
              <li><Link to="/araclar" className="hover:text-[#A11016] transition-colors">Tüm Araçlar</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">İletişim</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#A11016]" /><a href={`tel:${settings.phone_link}`} className="hover:text-white">{settings.phone}</a></li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#A11016]" /><a href={`mailto:${settings.email}`} className="hover:text-white">{settings.email}</a></li>
              <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-[#A11016] mt-0.5" /><span>{settings.address}</span></li>
              <li className="flex items-start gap-2"><Clock className="h-4 w-4 text-[#A11016] mt-0.5" /><span>{settings.working_hours}</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-neutral-500">© {new Date().getFullYear()} Voyacar Rent A Car. Tüm hakları saklıdır.</p>
          <ul className="flex flex-wrap gap-x-5 gap-y-2 text-xs">
            {LEGAL.map((l) => (
              <li key={l.to}><Link to={l.to} className="text-neutral-400 hover:text-[#A11016]">{l.label}</Link></li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
